import Button from "@Components/Button";
import WechatFilled from "@Icons/WechatFilled";
import getWeComUrlBasedOnSource, {
  HK_WEIXIN_DWEB,
  HK_WEIXIN_MWEB,
} from "helpers/getWeComUrlBasedOnSource";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useIsDesktop from "hooks/useIsDesktop";
import useTranslationHook from "hooks/useTranslationHook";
import { MouseEventHandler, useEffect, useState } from "react";
import styles from "./WeChatButton.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

interface WeChatButtonProps {
  className?: string;
  page: string;
}

const WeChatButton: React.FC<WeChatButtonProps> = ({ className = "", page }) => {
  const customWindowOpen = useCustomWindowOpen();
  const { t } = useTranslationHook();
  const isDesktop = useIsDesktop();
  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(
    isDesktop ? HK_WEIXIN_DWEB : HK_WEIXIN_MWEB,
  );

  useEffect(() => {
    const { URLDweb, URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(isDesktop ? URLDweb : URLMweb);
  }, [isDesktop]);

  const handleWeChatClick: MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    gtagEventEmitter({
      action: `clicked_continue_wechat_${page}`,
      category: page,
      page,
    });

    if (typeof window !== "undefined" && "_agl" in window) {
      // @ts-ignore
      window._agl.push(["track", ["success", { t: 35 }]]);
    }
    customWindowOpen({
      url: weChatSupportRedirectTo,
      target: isDesktop ? "_blank" : "_self",
      isExternal: true,
    });
  };

  return (
    <Button
      variant="none"
      LeftIcon={() => <WechatFilled />}
      onClick={handleWeChatClick}
      dataTestId="searchPage-inventoryCard-wechat-button"
      className={formatClassNames(styles.wechatButton, className)}
    >
      {t("Enquire Now")}
    </Button>
  );
};

export default wrapperHOC(WeChatButton, {
  componentName: "WeChatButton",
  showForChina: true,
});
